import { Component, Input } from '@angular/core';
import { PhoneTypes } from 'generated/graphql-types';
import { PhoneTypeConnectionStatus } from 'src/app/pages/extension-details/helpers/extension-status-helper';
import { roveHandsetIconName } from './rove-handset-icon';

// Silhouettes are deliberately dissimilar, because at this size anything rectangular reads the same.
// Hence a headset rather than a monitor for the softphone.
const phoneTypeIcons: Partial<Record<PhoneTypes, string>> = {
   [PhoneTypes.Hardphone]: 'call',
   [PhoneTypes.Softphone]: 'headset_mic',
   [PhoneTypes.Appsuite]: 'smartphone',
};

// Rove handsets use a hand-drawn svg because the Material Icons font has no cordless handset glyph.
const phoneTypeSvgIcons: Partial<Record<PhoneTypes, string>> = {
   [PhoneTypes.Handset]: roveHandsetIconName,
};

const phoneTypeLabels: Record<PhoneTypes, string> = {
   [PhoneTypes.Hardphone]: 'Hardphone',
   [PhoneTypes.Softphone]: 'Softphone',
   [PhoneTypes.Appsuite]: 'rmAppSuite',
   [PhoneTypes.Handset]: 'Rove Handset',
};

@Component({
   selector: 'phone-type-status-icons',
   styleUrls: ['./phone-type-status-icons.component.scss'],
   templateUrl: './phone-type-status-icons.component.html',
   standalone: false,
})
export class PhoneTypeStatusIconsComponent {
   @Input() statuses: PhoneTypeConnectionStatus[] | null = null;

   iconFor(status: PhoneTypeConnectionStatus): string {
      return phoneTypeIcons[status.phoneType] ?? 'call';
   }

   svgIconFor(status: PhoneTypeConnectionStatus): string | null {
      return phoneTypeSvgIcons[status.phoneType] ?? null;
   }

   stateFor(status: PhoneTypeConnectionStatus): string {
      if (status.connectedCount === 0) {
         return 'not-registered';
      }

      return status.connectedCount < status.sipUserCount ? 'partly-registered' : 'registered';
   }

   tooltipFor(status: PhoneTypeConnectionStatus): string {
      const label = phoneTypeLabels[status.phoneType] ?? '';

      if (status.sipUserCount <= 1) {
         return `${label}: ${status.connectedCount > 0 ? 'Registered' : 'Not registered'}`;
      }

      return `${label}: ${status.connectedCount} of ${status.sipUserCount} registered`;
   }
}
